import { AxiosInstance } from 'axios';
import { type UserData } from '../../../../types/isomorphic';
import apiUrl from '../apiUrl';

export class UserService {
  #httpClient: AxiosInstance;
  baseUrl: string;

  constructor(httpClient: AxiosInstance) {
    this.#httpClient = httpClient;
    this.baseUrl = `${apiUrl}/user`;
  }

  getUserData = (): Promise<UserData> =>
    this.#httpClient.get(`${this.baseUrl}`).then((response) => response.data);
}

export default UserService;
